import React from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, Grid, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Scrollbars } from 'react-custom-scrollbars-2';
import config from '../config/config';

const FAQ = () => {
    const theme = useTheme();

    return (
        <Box sx={{
            width: '100%',
            py: 2,
            position: 'relative',
            overflow: 'hidden',
            flexGrow: 1,
            marginRight: -1,
        }}>
            {/* Background Plate */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '99%',
                    height: '400px',
                    // background: `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                    borderRadius: '0 0 16px 16px',
                    boxShadow: '0px 20px 50px rgba(0, 0, 0, 0.2)',
                    zIndex: 0,
                }}
            ></Box>
            <Scrollbars>
                <Container maxWidth="md"
                    sx={{
                        backgroundColor: "background.default",
                        border: 1,
                        borderColor: "divider",
                        borderRadius: "0 0 16px 16px",
                    }}
                >
                    <Typography variant="h3" align="center" sx={{ fontWeight: 'bold', mb: 6 }}>
                        Frequently Asked Questions
                    </Typography>

                    <Grid container spacing={2}>
                        {faqData.map((faq, index) => (
                            <Grid item xs={12} key={index}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                            {faq.question}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography variant="body1">
                                            {faq.answer}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Scrollbars>
        </Box>
    );
};

const faqData = [
    {
        question: "What is Glassyfied, and how does it work?",
        answer: "Glassyfied is an AI-powered educational platform designed to assist students, teachers, and academic institutions. It provides tools and resources for learning and study support, enabling users to ask questions and get tailored responses powered by advanced AI models."
    },
    {
        question: "How do I sign up for an account?",
        answer: "Simply go to the Sign-Up page, fill in your details, and follow the prompts to create an account. You’ll receive a confirmation email to verify your email address."
    },
    {
        question: "What kinds of questions can I ask?",
        answer: "You can ask questions related to academic topics, research assistance, or even for study tips. Our AI models are trained to assist with a wide range of educational subjects and can provide insights, summaries, explanations, and more."
    },
    {
        question: "Is Glassyfied free to use?",
        answer: "Currently, Glassyfied is free to use. In the future, premium features may be introduced, and users will be notified if any changes occur regarding payment or subscription plans."
    },
    {
        question: "Can I upload documents for review?",
        answer: "Yes, you can upload documents in supported formats, and our AI models will analyze the content to provide summaries, answer questions based on the document, or offer other relevant insights."
    },
    {
        question: "How do I contact support if I need help?",
        answer: `You can contact support by emailing ${config.supportMail}, calling us at ${config.phoneNumber}, or using the Contact Us page to send a message directly to our team. We’re available 24/7 for any assistance.`
    },

    {
        question: "What file types are supported for uploads?",
        answer: "Currently, we support PDF, Word documents, and standard image files. More file types may be supported in the future as we expand our services."
    },
    {
        question: "How do I reset my password?",
        answer: "Go to the login page, click on 'Forgot Password,' and follow the instructions to reset your password. You’ll receive an email with a link to create a new password."
    },
    {
        question: "Is my data secure with Glassyfied?",
        answer: "Yes, we prioritize user data security by implementing strong encryption protocols and adhering to data privacy standards. Your information is handled with care and used solely to improve your experience."
    },
    {
        question: "What is the typical response time for questions asked on the platform?",
        answer: "Response times vary based on the complexity of the question, but most inquiries receive answers within a few seconds to a minute."
    },
    {
        question: "Can I personalize my learning experience?",
        answer: "Absolutely! Glassyfied uses AI to analyze your learning history and tailor recommendations for resources, study tips, and more to match your educational needs."
    },
    {
        question: "Are there mobile apps available for Glassyfied?",
        answer: "We are currently developing mobile applications for both Android and iOS platforms to offer users a seamless experience on their mobile devices. Stay tuned for updates!"
    },
    {
        question: "How can I provide feedback or suggest new features?",
        answer: "We value your feedback! You can submit feedback or feature suggestions via our Contact Us page or directly email our team at feedback@glassyfied.com."
    },
    {
        question: "Does Glassyfied support multiple languages?",
        answer: "At the moment, Glassyfied primarily supports English. We are working to expand support for additional languages to reach a broader user base."
    },
    {
        question: "How accurate are the AI-generated responses?",
        answer: "Our AI models are highly advanced, but like all AI, they are not perfect. We recommend verifying complex information, and our team continually works to improve accuracy and reliability."
    },
    {
        question: "What should I do if I encounter technical issues?",
        answer: `If you experience any technical problems, please contact support at ${config.supportMail}. You can also refer to our Help Center for troubleshooting steps on common issues.`
    },
    {
        question: "Are there limits to how many questions I can ask?",
        answer: "Currently, there are no strict limits on the number of questions you can ask. However, fair use policies may be applied to ensure quality of service for all users."
    },
    {
        question: "Can I save my previous conversations and access them later?",
        answer: "Yes, you can view and manage your conversation history in your profile. This allows you to review past questions and answers whenever needed."
    },
    {
        question: "How do I unsubscribe from the mailing list?",
        answer: "If you wish to unsubscribe, click the 'Unsubscribe' link at the bottom of any email or go to your account settings to manage your communication preferences."
    },
    {
        question: "Does Glassyfied offer customer support in multiple languages?",
        answer: "Currently, our support is available in English. We’re exploring options to expand multilingual support as we grow."
    },
];

export default FAQ;
